export const GET_TRANSACTION = 'TRANSACTION/get_transaction';
export const APPROVE_TRANSACTION = 'TRANSACTION/approve_transaction';
export const RECEIVE_TRANSACTION = 'TRANSACTION/receive_transaction';
export const UPDATE_TRANSACTION = 'TRANSACTION/update_transaction';
export const FETCH_RECORD = 'TRANSACTION/fetch_record';
export const SHOW_TRANSACTION = 'TRANSACTION/show_transaction';
export const START_ASSESSMENT = 'TRANSACTION/start_assessment';
export const REJECT_TRANSACTION = 'TRANSACTION/reject';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const SYNC_RECORD = 'TRANSACTION/SYNC_RECORD';
export const RECOMPUTE = 'TRANSACTION/recompute';
export const UPDATE_BUSINESS_TRANSACTION = 'BPLS/update_business_transaction';
export const ADD_BUSINESS_REMARKS = 'BPLS/add_business_remarks';
export const BPLS_TEMP_REVOKE = 'BPLS/revoke';
export const BPLS_TRANSMITTAL =
  'api/v1/administrators/transaction_histories/transmital/generate';
export const MANUAL_PAYMENT_POSTING = 'TRANSACTION/manual_payment_posting';
export const DELETE_TRANSACTION = 'TRANSACTION/delete';
export const UPDATE_PAID_DATE = 'TRANSACTION/update_paid_date';
export const REGENERATE_FEES = 'TRANSACTION/regenerate_fees';
export const REGENERATE_FEE_TRANSACTION =
  'TRANSACTION/regenerate_fee_transaction';

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
  tax_payer_first_name: '',
  tax_payer_middle_name: '',
  tax_payer_last_name: '',
  tax_payer_extension_name: '',
  business_name: '',
  bin: '',
  capital_amount: '',
  gross_amount: '',
  paid_date: '',
};

export const PERIOD_OPTIONS = [
  {
    label: '1st Quarter',
    value: 1,
  },
  {
    label: '2nd Quarter',
    value: 2,
  },
  {
    label: '3rd Quarter',
    value: 3,
  },
  {
    label: '4th Quarter',
    value: 4,
  },
];

export const TBPLS_URI =
  'api/temp/administrators/transaction_histories/ovr/{id}/soa';
export const TBPLS_URI_GENERATE =
  'api/temp/administrators/transaction_histories/business_permit/{id}/preview_soa';
export const TBPLS_OR_URI_GENERATE =
  'api/temp/administrators/transaction_histories/business_permit/{id}/preview_or';
export const TBPLS_PERMIT_URI_GENERATE =
  'api/temp/administrators/transaction_histories/business_permit/{id}/preview_permit';
export const TBPLS_APPLICATION_URI_GENERATE =
  'api/temp/administrators/transaction_histories/business_permit/{id}/preview_application';

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];
